interface StubFeatureProps {
  title: string
  description?: string
}

export function StubFeature({ title, description }: StubFeatureProps) {
  return (
    <div className="w-full min-h-[300px] border-2 border-dashed border-border-default rounded-xl bg-bg-surface flex flex-col items-center justify-center p-8 gap-4">
      <div className="w-16 h-16 rounded-lg bg-bg-default border border-dashed border-border-default flex items-center justify-center">
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          className="text-fg-secondary"
        >
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <path d="M3 9h18" />
          <path d="M9 21V9" />
        </svg>
      </div>
      <div className="text-center">
        <p className="text-lg font-medium text-fg-default">{title}</p>
        {description && (
          <p className="text-sm text-fg-secondary mt-2 max-w-[300px]">
            {description}
          </p>
        )}
      </div>
      <p className="text-xs text-fg-tertiary mt-2">
        Placeholder - Content coming soon
      </p>
    </div>
  )
}
